<template>
  <autocomplete-multiple name="Специальность" :items="items" :select.sync="localSelect" @load="load" :loading="loadState.isLoading">
    <template v-slot:itemIcon="{item}">
      <v-avatar :color="item.color" size="10" class="mr-1" style="margin-top:-3px"/>
    </template>
    <template v-slot:selectedInfo="{item}">
      <v-avatar :color="item.color" size="10" class="mr-1" style="margin-top:-2px"/> {{item.name}}
    </template>
  </autocomplete-multiple>
</template>

<script>
import State from "@/plugins/state";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import {
  Entity_Spec,
} from "../../../EntityStoreCacheService";

export default {
  components: {AutocompleteMultiple},
  props:[
    'select','globalState'
  ],
  data:()=>({
    loadState: new State(),
    items: [],
    localSelect: null
  }),
  watch: {
    select() {
      if (Array.isArray(this.select) ? this.select.length > 0 : !!this.select) // для сохраненных фильтров
         this.load();

      this.localSelect = this.select;
    },
    localSelect() {
      this.$emit('update:select', this.localSelect)
      if(typeof this.globalState!=='undefined'){
        let arr = this.localSelect;
        arr.forEach((v)=>{
          v.id = parseInt(v.id);
        });
        localStorage['globalState_specs'] = JSON.stringify(arr);
      }
    }
  },
  mounted() {
    this.localSelect = this.select;
    if(typeof this.globalState!=='undefined' && typeof localStorage['globalState_specs']!=='undefined') {
      let arr = JSON.parse(localStorage['globalState_specs']);
      if(arr.length>0){
        arr.forEach((v)=>{
          v.id = parseInt(v.id);
        });
        this.localSelect = arr;
        this.load();
      }
    }
  },
  methods:{
    load(){
      if (this.items.length===0) {
        new Entity_Spec()
          .selects(Entity_Spec.id)
          .selects(Entity_Spec.name)
          .selects(Entity_Spec.color)
          .order(Entity_Spec.name, true)
          .filterAnd([Entity_Spec.entity, Entity_Spec.status].join('.')+'=?','active')
          .page(1).onPage(1000)
          .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
          .request((v)=>{
              this.items = v.items;
          }, (e)=>{
            console.error(e.response.data.message);
          })  
      } 
    }
  }
}
</script>